import { initialState } from "@/models/options";

const v21 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        editorialDistributionTable: {
          ...initialState.tableViews.editorialDistributionTable,
        },
      },
    },
  };
};

export default v21;
